var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9829 0.353586C15.1781 0.158306 15.4947 0.158306 15.6899 0.353586L18.7017 3.36594C18.897 3.56122 18.897 3.87783 18.7017 4.07311L16.824 5.95124L13.1051 2.23171L14.9829 0.353586Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0795 3.21875L15.8165 6.95643L6.89125 15.8833L3.15427 12.1456L12.0795 3.21875Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10369 13.2139L5.78515 16.896L0.604139 18.7804C0.364737 18.8674 0.132613 18.6353 0.219656 18.3959L2.10369 13.2139Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPen);
export default __webpack_public_path__ + "static/media/black-pen.e0851ed1c61ca0ac07ce7f47d3a5c668.svg";
export { ForwardRef as ReactComponent };